import {
  Box,
  HelpOutlineIcon,
  IconButtonAnchor,
  makeStyles,
  Theme,
  Toolbar,
  Tooltip,
} from '@freighthub/silhouette-core'
import { useObserver } from 'mobx-react-lite'
import { FC } from 'react'
import { useAuth } from 'service/useAuth'
import { useI18n } from 'utils/localisation'

import { LOGO_URL_DARK_SVG } from '../logoUrls'
import { LanguageSelect } from './LanguageSelect'
import { TopBar } from './TopBar/TopBar'

const COMPANY_WEBSITE_URL = 'https://forto.com'

const useStyles = makeStyles<Theme>((theme) => ({
  toolbar: {
    zIndex: theme.zIndex.appBar,
    justifyContent: 'space-between',
    minHeight: 0,
    height: 60,
    boxShadow: theme.shadows[2],
    padding: theme.spacing(0, 1.5, 0, 3),
    backgroundColor: theme.palette.background.paper,
  },
  logo: {
    height: 20,
    width: 80,
  },
}))

export const Header: FC = () =>
  useObserver(() => {
    const classes = useStyles({})
    const { translate } = useI18n()
    const authStore = useAuth()
    const { authenticated, customerLoaded } = authStore.state

    if (!authenticated) {
      return (
        <Toolbar className={classes.toolbar}>
          <Box display="flex" alignItems="center">
            <a href={COMPANY_WEBSITE_URL} className={classes.logo}>
              <img src={LOGO_URL_DARK_SVG} alt="forto-logo" />
            </a>
          </Box>
          <Box display="flex" alignItems="center">
            <Tooltip title={translate('header-faq')}>
              <IconButtonAnchor href={translate('FAQ_URL')} id="header-faq" target="_blank">
                <HelpOutlineIcon />
              </IconButtonAnchor>
            </Tooltip>

            <LanguageSelect />
          </Box>
        </Toolbar>
      )
    }

    if (!customerLoaded) {
      return null
    }

    return <TopBar />
  })
